<template>
  <section class="pageInner">
    <spinner v-if="loading" full/>
    <header>
      <h4>Quase lá.. Agora vamos iniciar seu pagamento</h4>
      <p>Antes de continuar, valide os dados abaixo:</p>
    </header>
    <div v-if="proposta">
      <div class="finalValue">
        <div>
          <p>Valor Final</p>
          <h3> {{ formatMoney(proposta.proposta.jsonProposta.debitos.valor)  }}</h3>
        </div>
      </div>
      <div class="checkout" v-if="proposta && proposta.proposta.jsonProposta.debitos.formaPagamentoEntrada">
        <header>
          <h4>Entrada</h4>
        </header>
        <div>
          <span>
            <p>Valor</p>
            <b>{{ formatMoney(dropValor('entrada')) }} </b>
          </span>
          <span>
            <p>Forma de Pagamento</p>
            <b>{{ metodos[proposta.proposta.jsonProposta.debitos.formaPagamentoEntrada] }}</b>
          </span>
          <span>
            <p>Vencimento</p>
            <b>{{ formatDate(proposta.proposta.jsonProposta.debitos.parcelas[0].vencimento) }}</b>
          </span>
          <span>
            <p>Parcelamento</p>
            <b>
              {{ 
                proposta.proposta.nParcelasEntrada == 0 || proposta.proposta.nParcelasEntrada == 1 ? 
                `1x de ${ formatMoney( proposta.proposta.jsonProposta.debitos.parcelas[0].valor ) }` :
                `${ proposta.proposta.nParcelasEntrada }x de ${ formatMoney( dropValor('parcelas') * proposta.proposta.nParcelasEntrada ) }` }}
            </b>
          </span>
        </div>
        <div class="addCard" v-if="proposta.proposta.jsonProposta.debitos.formaPagamentoEntrada == 'cartao'">
          <span>
            <p v-if="cartao.numero">
              <fa :icon="['fas', 'credit-card']" /> 
              Cartão informado: <b>{{ hiddenCartao(cartao) }}</b>
            </p>
          </span>
          <a href="#" class="btn btn-success-2 btn-squared-large" @click.prevent="toggleModalCartao('entrada')">
            <fa :icon="['fas', 'credit-card']" />  {{ cartao.numero ? 'Trocar cartão' : 'Inserir dados do cartão'}}
          </a>
        </div>
      </div>
      <div class="checkout" v-if="proposta && proposta.proposta.jsonProposta.debitos.formaPagamentoParcelas">
        <header>
          <h4>Parcelas</h4>
        </header>
        <div>
          <span>
            <p>Valor</p>
            <b>{{ formatMoney(dropValor('parcela')) }} </b>
          </span>
          <span>
            <p>Forma de Pagamento</p>
            <b>{{ metodos[proposta.proposta.jsonProposta.debitos.formaPagamentoParcelas] }}</b>
          </span>
          <span v-if="proposta.proposta.nParcelasEntrada">
            <p>Vencimento</p>
            <b>{{ formatDate(proposta.proposta.jsonProposta.debitos.parcelas[proposta.proposta.nParcelasEntrada + 1].vencimento) }}</b>
          </span>
          <span>
            <p>Parcelamento</p>
            <b>
              {{ 
                !proposta.proposta.nParcelas ? `1x de ${ formatMoney( dropValor('parcela')) }` : (
                proposta.proposta.nParcelas == 0 || proposta.proposta.nParcelas == 1 ? 
                ( `1x de ${ formatMoney( dropValor('parcela') / proposta.proposta.nParcelas ) }` ) :
                `${ proposta.proposta.nParcelas }x de ${ formatMoney( dropValor('parcela') / proposta.proposta.nParcelas ) }` )
              }}
            </b>
          </span>
        </div>
        <div class="addCard" v-if="proposta.proposta.jsonProposta.debitos.formaPagamentoParcelas == 'cartao'">
          <span>
            <p v-if="cartao.numero">
              <fa :icon="['fas', 'credit-card']" /> 
              Cartão informado: <b>{{ hiddenCartao(cartao) }}</b>
            </p>
          </span>
          <a href="#" class="btn btn-success-2 btn-squared-large" @click.prevent="toggleModalCartao('parcelas')">
            <fa :icon="['fas', 'credit-card']" />&nbsp;{{ cartao.numero ? 'Trocar cartão' : 'Inserir dados do cartão'}}
          </a>
        </div>
      </div>
    </div>
    <div :class="['cartaoModal', { active: cartaoModal.active }]">
      <div>
        <div>
          <header>
            <h3>Insira abaixo, os dados do cartão de crédito</h3>
            <p>Você deve utilizar um cartão do mesmo titular da dívida. <b>Sujeito a recusa.</b></p>
          </header>
          <div class="cartaoModalContent">
            <!-- <h4>{{ currentUser.nome }}</h4>
            <p>{{ maskCPF(currentUser.cadastro.Documento.cpf) }}</p> -->
          </div>
          <div class="row nop nom" ref="cartao">
            <div class="col-sm-12 form-group">
              <input-control v-model="cartao.numero" type="number" placeholder="4567 1234 9876 3210" label="Número" name="numero" :valid="valid.numero" @keyup="valid.numero = true" required/>
            </div>
            <div class="col-sm-12 form-group">
              <input-control v-model="cartao.nome" label="Nome do cartão" name="nome" :valid="valid.nome" @keyup="valid.nome = true" required/>
            </div>
            <div class="col-sm-8 form-group flex">
              <label>Validade</label>
              <div>
                <select-control v-model="cartao.validade.mes" :options="options.cartao.meses" name="mes" placeholder="MM" :valid="valid.mes" @change="valid.mes = true" flex required/>
                <!-- <span>/</span> -->
                <select-control v-model="cartao.validade.ano" :options="options.cartao.anos" name="ano" placeholder="AAAA" :valid="valid.ano" @change="valid.ano = true" flex required/>
              </div>
            </div>
            <div class="col-sm-4 form-group">
              <input-control v-model="cartao.cvv" type="number" name="cvv" :valid="valid.cvv" @keyup="valid.cvv = true" label="CVV" required/>
            </div>
          </div>
          <footer>
            <a href="#" class="btn btn-success-2 btn-squared-large" @click.prevent="saveCartao()">
              Salvar
            </a>
            <a href="#" class="btn btn-bg btn-bg-noborder btn-squared-large" @click.prevent="toggleModalCartao(false)">
              Cancelar
            </a>
          </footer>
        </div>
      </div>
    </div>
    <footer>
      <button-nav @onClick="finalizar()" :disabled="!ready">
        Finalizar
      </button-nav>
    </footer>
  </section>
</template>

<script>
import { formatMoney, formatDate, maskCPF } from '@/services/utils.service.js'
import ButtonNav from '@/components/financeiro/negocieja/app/navigation/ButtonNav.vue'
import FormService from '@/services/form.service.js'
import NegociaService from '@/services/negocieja.service.js'
import Spinner from '@/components/financeiro/negocieja/app/utilities/Spinner.vue'

export default {
  components: {
    ButtonNav, Spinner
  },
  props: {
    session: {
      type: String
    },
    step: {
      type: String
    },
    steps: {
      type: Array
    },
    debitos: {
      type: Object
    }
  },
  data () {
    return {
      checkout: null,
      proposta: null,
      metodos: {
        boleto: 'Boleto',
        pix: 'Pix',
        cartao: 'Cartão'
      },
      cartaoModal: {
        active: false,
        type: null
      },
      cartao: {
        numero: null,
        nome: null,
        cvv: null,
        validade: {
          mes: null,
          ano: null
        }
      },
      options: {
        cartao: {
          meses: [],
          anos: []
        }
      },
      valid: {
        numero: true,
        nome: true,
        cvv: true,
        mes: true,
        ano: true
      },
      ready: false,
      currentUser: localStorage.getItem('profile') ? JSON.parse(atob(localStorage.getItem('profile'))) : null,
      hasCartaoEntrada: false,
      hasCartaoParcelas: false,
      cartaoEntrada: false,
      cartaoParcelas: false,
      loading: false
    }
  },
  mounted () {
    this.$store.dispatch('negocieja/get').then(response => {
      console.log("negocieja checkout:", response)
      this.proposta = response
      this.createOptions()

      console.log("proposta:", this.proposta)
      const { formaPagamentoEntrada, formaPagamentoParcelas } = response.proposta.jsonProposta.debitos
      if ( formaPagamentoEntrada || formaPagamentoParcelas ) {
        if ( formaPagamentoEntrada == 'cartao' ) this.hasCartaoEntrada = true
        if ( formaPagamentoParcelas == 'cartao' ) this.hasCartaoParcelas = true
      }

      this.toggleReady()
    })
  },
  methods: {
    formatMoney ( value ) {
      return formatMoney(value)
    },
    formatDate ( date ) {
      return formatDate(date)
    },
    maskCPF ( cpf ) {
      return maskCPF(cpf)
    },
    dropValor ( type ) {
      const data = this.proposta.proposta.jsonProposta.debitos.parcelas

      const parsed = data.reduce((acc, item) => {
          // if the key doesn't exist yet, initialize with 0
          if (!acc[item.tipoArrecadacao]) {
            acc[item.tipoArrecadacao] = 0
          }
          // add the valor to the right tipoArrecadacao
          acc[item.tipoArrecadacao] += item.valor
          return acc
        }, {})

      return parsed[type]
    },
    createOptions () {
      for ( let i = 0; i < 12; i++) {
        const mes = this.addZero(i + 1)
        this.options.cartao.meses.push({label: mes, value: mes })
      }
      var ini = 2025
      for ( let i = 0; i < 11; i++) {
        const year = ini + i
        this.options.cartao.anos.push({label: year, value: year })
      }
    },
    addZero ( value ) {
      return String(value).padStart(2, "0")
    },
    toggleModalCartao ( type ) {
      if ( !type ) {
        this.cartao = {
          numero: null,
          nome: null,
          cvv: null,
          validade: {
            mes: null,
            ano: null
          }
        }
        this.cartaoModal.active = false
        this.cartaoModal.type = null
      } else {
        this.cartaoModal.active = true
        this.cartaoModal.type = type
      }
    },
    saveCartao () {
      const valid = FormService.validate(this.$refs.cartao, this.valid)
 
      if ( valid.response ) {
        const cartao = this.cartao
        const type = this.cartaoModal.type

        this.proposta.pagamento[type].cartao = {
          numero: cartao.numero,
          nome: cartao.nome,
          cvv: cartao.cvv,
          validade: `${cartao.validade.mes}/${cartao.validade.ano}`
        }

        this.cartaoModal.active = false

        this.toggleReady(type)
      }
    },
    toggleReady ( type ) {
      if ( type == 'entrada' && this.hasCartaoEntrada ) {
        this.cartaoEntrada = true
      } 
      if ( type == 'parcelas' && this.hasCartaoParcelas ) {
        this.cartaoParcelas = true
      }
      if ( !this.hasCartaoEntrada ) this.cartaoEntrada = true
      if ( !this.hasCartaoParcelas ) this.cartaoParcelas = true

      this.ready = this.cartaoEntrada && this.cartaoParcelas
    },
    hiddenCartao () {
      if ( !this.cartao.numero ) return false

      return this.cartao.numero.slice(-4)
    },
    finalizar () {
      this.loading = true
      const type = this.hasCartaoEntrada ? 'entrada' : this.hasCartaoParcelas ? 'parcelas' : false
      let data = this.proposta.proposta.jsonProposta

      if ( type ) {
        data['cartao'] = this.proposta.pagamento[type].cartao
      }
      
      NegociaService.negociar( data )
      .then( response => {
        console.log("negociar:", response.data)
        this.proposta.checkout = response.data
        this.$emit('onNext')
      })
      .catch( error => {
        console.error(error)
        const message = error.response.data?.message ?? 'Procure nossa equipe de atendimento.'
        window.toaster.emit('open', {
          style: 'error',
          message: `Não foi possível efetuar seu pagamento: ${ message }`,
          floater: true
        })
      })
      .finally(() => {
        this.loading = false
      })
      console.log("this.proposta:", this.proposta)
    }
  }
}
</script>

<style lang="scss" scoped>
  .pageInner {
    color: $preto-2;
    z-index: 5;
    display: flex; flex-direction: column;
    overflow: auto;
    height: 100%;

    >header {
      padding: $hmg_mid 40px;
      
      @media screen and ( max-height: 689px ) {
        padding: $hmg_mid;
      }

      >h4 {
        max-width: 540px;
        z-index: 3;
        flex-shrink: 0; 
      }

      p {
        margin: 0;
      }
    }

    >footer {
      padding: $hmg_large;
      
      @media screen and ( max-height: 689px ) {
        padding: $hmg_mid;
      }
    }

    .checkout {
      padding: $hmg_mid 40px;

      @media screen and ( max-height: 689px ) {
        padding: $hmg_mid;
      }

      header {
        display: flex; align-items: center;
        justify-content: space-between;
        margin-bottom: $mg_mini;
      }

      >div {
        span {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: $mg_mini 0;
          border-bottom: 1px solid $color-secondary;

          p {
            padding: 0; margin: 0;
            font-size: 1rem;
          }
          b {
            font-size: 1.1rem;
          }
        }
      }
    }

    .addCard {
      display: flex; justify-content: space-between;
      padding: $hmg_mid 0;

      p {
        margin: 0; padding: 0; 
        
      }
      span {
        border-bottom: 0 !important; 
        padding: 0 !important; margin: 0;
      }

      a {
        font-size: 1.1rem;
      }
    }
    .finalValue {
      padding: $hmg_mid 40px;
      
      @media screen and ( max-height: 689px ) {
        padding: 0 $hmg_mid $hmg_mid;
      }

      >div {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: $hmg_mid;
        background-color: $color-secondary;
        border-radius: $border-radius;

        p {
          padding: 0; margin: 0;
          text-transform: uppercase;
        }

        h3 {
          padding: 0; margin: 0;
        }
      }
    }

    .cartaoModal {
      display: flex;
      flex-direction: column; justify-content: center;
      align-items: center;
      position: fixed; width: 100%; height: 100%;
      top: 0; left: 0; right: 0;
      z-index: 300;
      pointer-events: none;
      @extend %transition_4o;

      >div {
        display: flex; 
        flex-direction: column; justify-content: space-between;
        transform: translateY(calc(100% + 50vw));
        transition-delay: .2s;
        background-color: $color-secondary;
        z-index: 301;
        padding: $hmg_mid;
        max-width: 340px; width: 100%;
        border-radius: $border-radius-large;

        @extend %transition_6e;

        .cartaoModalContent {
          padding: $mg_mini;
        }

        header {
          padding: $mg_mini;
        }

        footer {
          padding: $mg_mini;
          display: flex; justify-content: space-between;
          a {
            font-size: 1.2rem;
          }
        }

        .flex {
          > div {
            display: flex; align-items: stretch;
            gap: $hmg_mini;

            >* {
              flex: 1
            }
          }
        }
      }
      
      &.active {
        pointer-events: all;
        backdrop-filter: blur(5px);

        >div {
          transform: translateY(0);
        }
        
      }
    }
  }
</style>